"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorage = void 0;
class LocalStorage {
    constructor() {
        this.keys = [];
        //return MemoryProxyStorage.applyProxy(this, "SessionStorage") as SessionStorage;
    }
    isSupported() {
        return true;
        // let result;
        // try {
        //     const key = "isSupportedSessionStorageKey";
        //     const value = "isSupportedSessionStorageValue";
        //     sessionStorage.setItem(key, value);
        //     if (sessionStorage.getItem(key) === value) {
        //         sessionStorage.removeItem(key);
        //         result = true;
        //     }
        // } catch (ex) {
        //     result = false
        // } finally {
        //     return result;
        // }
    }
    getParsed(key) {
        try {
            return JSON.parse(localStorage.getItem(key));
        }
        catch (ex) {
            return null;
        }
    }
    get(key) {
        try {
            return localStorage.getItem(key);
        }
        catch (ex) {
            return null;
        }
    }
    set(key, data) {
        let success;
        try {
            localStorage.setItem(key, data);
            this.addKey(key);
            success = true;
        }
        catch (ex) {
            success = false;
        }
        finally {
            return success;
        }
    }
    delete(key) {
        let success;
        try {
            localStorage.removeItem(key);
            this.removeKey(key);
            success = true;
        }
        catch (ex) {
            success = false;
        }
        finally {
            return success;
        }
    }
    clear() {
        let success;
        try {
            for (let key of this.keys) {
                this.delete(key);
            }
            return true;
            // sessionStorage.clear();
            // success = true;
        }
        catch (ex) {
            success = false;
        }
        finally {
            return success;
        }
    }
    getAllKeys() {
        return this.keys;
    }
    getAllItems() {
        const items = [];
        try {
            for (let key of this.keys) {
                items.push({ key: key, val: this.get(key) });
            }
            return items;
        }
        catch (ex) {
            return items;
        }
    }
    addKey(expandKey) {
        const index = this.keys.indexOf(expandKey);
        if (index === -1) {
            this.keys.push(expandKey);
        }
    }
    removeKey(expandKey) {
        const index = this.keys.indexOf(expandKey);
        if (index !== -1) {
            this.keys.splice(index, 1);
        }
    }
}
exports.LocalStorage = LocalStorage;
